import { v4 as uuid } from 'uuid';

import { startPollingMessages } from './startPollingMessages';
import { setChatbotOnboardingButtons } from '../../actions/chatbot/actions';
import { addTextMessageToChat } from '../../actions/sendMessage';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { TChatbotPayload, fetchChatbotActionButtons } from '../../services/сhatbot/fetchChatbotActionButtons';
import { TThunkAction } from '../../types/redux/thunk';

export const getChatbotActionButtons =
  (payload: TChatbotPayload, message?: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const messageId = uuid();

    if (message) {
      dispatch(addTextMessageToChat(message, CHATBOT_ID, messageId));
    }

    await fetchChatbotActionButtons(context, payload);

    if (payload !== 'initial') {
      dispatch(setChatbotOnboardingButtons([]));
      dispatch(
        startPollingMessages({
          isQuick: true,
          messageIdToDelete: message && messageId,
        }),
      );
    }
  };
